import { usePathname } from 'next/navigation';
import { useCallback } from 'react';

type UseSetSelectedChipsIdsToURL = {
	chosenSubcategoryIds: Array<string>;
	setChosenSubcategoryIds: (value: Array<string>) => void;
};

export const useSetSelectedChipsIdsToURL = ({
	chosenSubcategoryIds,
	setChosenSubcategoryIds
}: UseSetSelectedChipsIdsToURL) => {
	const currentPath = usePathname();

	const addHashToLocation = useCallback(
		(param: string, clear: boolean) => {
			window.history.replaceState({}, '', clear ? currentPath : currentPath + param);
		},
		[currentPath]
	);

	const createQueryString = useCallback(
		(id: Array<string>) => {
			const urlParams = new URLSearchParams();

			urlParams.set('?selected', id.join(','));

			return addHashToLocation(decodeURIComponent(urlParams.toString()), chosenSubcategoryIds[0] === 'all');
		},
		[addHashToLocation, chosenSubcategoryIds]
	);

	const chipsSelected = useCallback((value: Array<string>) => {
		createQueryString(value);
		setChosenSubcategoryIds(value);
	}, []);

	return {
		chipsSelected
	};
};
